import { render } from "./TagSelection.vue?vue&type=template&id=2c17ebdd"
import script from "./TagSelection.vue?vue&type=script&lang=js"
export * from "./TagSelection.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/OpenMCT/OpenMCT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__